// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2otFg","item":"PaymentsMobile_item__3sUfS","label":"PaymentsMobile_label__2fZDW","amount":"PaymentsMobile_amount__2c06d"};